export default __webpack_public_path__ + "static/Scrap-Metal-Removal-b93ac9cf287a41c6a853fca51aa574f7.jpg";